export const actionNodeDetachOffset = -60;
export const actionNodeDependencyOffset = 120;
export const maxZoom = 2.5;
export const minZoom = 0.1;
